export class Partner {
    id: number;
    code: string;
    name: string;
    fiscalCode: string;
    registryNumber: string;
    address: string;
    contactInfo: string;
    bank: string;
    bankAccount: string;
    payingAccount: string;
    erpCode: string;
    partnerId: number;
    state: any;
}